// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import dataTableStyles from "@synd/App/SharedStyles/DataTableStyles";
import { recentQuotesStyles } from "@synd/Overrides/Widgets/Common/RecentQuotes";
import { createLinkIconStyles } from "@synd/XDL/Utilities";
import { css } from "styled-components";

recentQuotesStyles.noQuotesGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentQuotesStyles.noQuotesText = {
    ...dataTableStyles.noResultsText,
};

recentQuotesStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

recentQuotesStyles.titleTypographyStyles = {
    link: {
        ...createLinkIconStyles({
            icon: ChevronRight,
            sizeVariant: "small",
            variant: "primary",
            linkStyles: {
                icon: {
                    position: "right",
                },
            },
        }),
    },
};
